/**
 * PROFILE
 */
export const PROFILE_SET_DATA = 'profileSetData'
export const PROFILE_SET_ERROR = 'profileSetError'
export const PROFILE_TOGGLE_LOADING = 'profileToggleLoading'
export const PROFILE_METRICS_SET_DATA = 'profileMetricsSetData'
export const NOTIFICATIONS_SET_DATA = 'notificationsSetData'
